import { FluentProvider, Label, LabelProps, PartialTheme, webDarkTheme, webLightTheme } from '@fluentui/react-components';


interface LabelCustomProps {
    rcName?: string;
    theme?: string;
}


const LabelCustom = (props: LabelCustomProps & LabelProps) => {
    const renderTheme: PartialTheme =
        props.theme === "dark" ? webDarkTheme : webLightTheme;
    return (
        <FluentProvider theme={renderTheme}>
          <Label {...props} />
        </FluentProvider>
    );
};

export default LabelCustom;